import type { Translate } from 'types'
import { hexToRGBA } from 'utils'

const COMPARED_OPACITY = 0.6

export const detectColors = (clusterType: string) => {
  switch (clusterType) {
    case 'F':
    case 'CCC':
      return {
        avgRevenueColor: '#470024',
        avgRevenueComparedColor: hexToRGBA('#470024', COMPARED_OPACITY),
      }
    case 'S':
    case 'Modivo':
      return {
        avgRevenueColor: '#a3320b',
        avgRevenueComparedColor: hexToRGBA('#a3320b', COMPARED_OPACITY),
      }
    case 'A':
    case 'eObuwie':
      return {
        avgRevenueColor: '#882d02',
        avgRevenueComparedColor: hexToRGBA('#882d02', COMPARED_OPACITY),
      }
    case 'B':
    case 'Gino Rossi':
      return {
        avgRevenueColor: '#d24504',
        avgRevenueComparedColor: hexToRGBA('#d24504', COMPARED_OPACITY),
      }
    case 'C':
    case 'DeeZee':
      return {
        avgRevenueColor: '#f07e06',
        avgRevenueComparedColor: hexToRGBA('#f07e06', COMPARED_OPACITY),
      }
    case 'V':
    case 'X':
      return {
        avgRevenueColor: '#411501',
        avgRevenueComparedColor: hexToRGBA('#411501', COMPARED_OPACITY),
      }
    case 'K':
      return {
        avgRevenueColor: '#000000',
        avgRevenueComparedColor: hexToRGBA('#000000', COMPARED_OPACITY),
      }
    case 'Z':
      return {
        avgRevenueColor: '#faa275',
        avgRevenueComparedColor: hexToRGBA('#faa275', COMPARED_OPACITY),
      }
    case 'E':
      return {
        avgRevenueColor: '#124719',
        avgRevenueComparedColor: hexToRGBA('#124719', COMPARED_OPACITY),
      }
    case 'EA':
      return {
        avgRevenueColor: '#1c6d27',
        avgRevenueComparedColor: hexToRGBA('#1c6d27', COMPARED_OPACITY),
      }
    case 'EB':
      return {
        avgRevenueColor: '#238230',
        avgRevenueComparedColor: hexToRGBA('#238230', COMPARED_OPACITY),
      }
    case 'EC':
      return {
        avgRevenueColor: '#31a040',
        avgRevenueComparedColor: hexToRGBA('#31a040', COMPARED_OPACITY),
      }

    case 'G':
      return {
        avgRevenueColor: '#0b0f15',
        avgRevenueComparedColor: hexToRGBA('#0b0f15', COMPARED_OPACITY),
      }
    case 'GA':
      return {
        avgRevenueColor: '#243146',
        avgRevenueComparedColor: hexToRGBA('#243146', COMPARED_OPACITY),
      }
    case 'GB':
      return {
        avgRevenueColor: '#39475d',
        avgRevenueComparedColor: hexToRGBA('#39475d', COMPARED_OPACITY),
      }
    case 'GC':
      return {
        avgRevenueColor: '#677686',
        avgRevenueComparedColor: hexToRGBA('#677686', COMPARED_OPACITY),
      }
    case '':
      return {
        type: '-',
        avgRevenueColor: '#6849bc',
        avgRevenueComparedColor: hexToRGBA('#6849bc', COMPARED_OPACITY),
      }
    default:
      return {
        type: clusterType,
        avgRevenueColor: '#6849bc',
        avgRevenueComparedColor: hexToRGBA('#6849bc', COMPARED_OPACITY),
      }
  }
}

export interface GetMissingDataTextProps {
  count: number
  countActive?: number
  revenue?: number
}

export const getMissingDataText = (key: string, { count, countActive, revenue }: GetMissingDataTextProps, translate: Translate) => {
  let type = key

  if (count === 0 && !countActive) {
    type = translate('revenue.type.active')
  } else if (count === 0 && countActive! > 0) {
    type = translate('revenue.type.open')
  } else if (count > 0 && revenue === 0) {
    type = translate('revenue.type.selling')
  } else if (count > 0 && !revenue) {
    type = translate('revenue.type.reporting')
  }

  return translate(key, { type })
}
